"use client";

import { KeyValueQuery } from "@server/gql/graphql";
import { createContext, PropsWithChildren, useMemo } from "react";

type TranslationMap = Partial<Record<string, string>>;

export const TranslationContext = createContext<TranslationMap | undefined>(
  undefined,
);

export default function TranslationProvider({
  children,
  translations,
}: PropsWithChildren<{
  translations?: KeyValueQuery;
}>) {
  const items = translations?.keyValueCollection?.items;
  const translationsMap = useMemo(
    () =>
      items?.reduce<Partial<Record<string, string>>>((acc, item) => {
        if (!item?.key) {
          return acc;
        }

        if (!item.value) {
          return {
            ...acc,
            [item.key]: `!${item.key}`,
          };
        }

        return {
          ...acc,
          [item.key]: item.value,
        };
      }, {}),
    [items],
  );

  return (
    <TranslationContext.Provider value={translationsMap}>
      {children}
    </TranslationContext.Provider>
  );
}
